import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { profileSections, sectionCard } from './style.css'
import PersonalInfoPanel from './PersonalInfoPanel'
import EduHistoryPanel from './EduHistoryPanel'
import InterestsPanel from './InterestsPanel'
import DesiredJobPanel from './DesiredJobPanel'

export default function UserInfo() {
  return (
    <>
      <div className={profileSections}>
        <div className={sectionCard}>
          <PersonalInfoPanel />
        </div>
        <div className={sectionCard}>
          <EduHistoryPanel />
        </div>
      </div>
      <Row className="mb-3">
        <Col>
          <InterestsPanel />
        </Col>
      </Row>
      <Row>
        <Col>
          <DesiredJobPanel />
        </Col>
      </Row>
    </>
  )
}
